/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */

export default {
    name: 'flzy',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'法律资源',
                key:'flzy'
            }]),
            data: {
                sfjs: {
                    image: '/static/image/ejym/flzy/img-sfjs.png',
                    data: []
                },
                flfg: {
                    image: '/static/image/ejym/flzy/img-flfg.png',
                    data: []
                },
                zdxwj: {
                    image: '/static/image/ejym/flzy/img-zdxwj.png',
                    data: [
                    ]
                },
                tyygl:{
                    image:'/static/image/ejym/ywsf/img-gjgy.png',
                    data:[]
                },
                ywfl: {
                    image: '/static/image/ejym/ywsf/img-ywfl.png',
                    data: []
                }
            }
        };
    },
    created() {
        this.initdata();
    },
    methods: {
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/flzy/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active:'flzy', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
        },
        initdata() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.hsalindex.replace('{id}', '3')
            }).then((res) => {
                this.data.sfjs.data = res.data.sfjs;
                this.data.flfg.data = res.data.flfg;
                this.data.zdxwj.data = res.data.zdxwj;
                this.data.tyygl.data = res.data.gjgy;
                this.data.ywfl.data = res.data.ywfl;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        }
    }
};

